export default import.meta.ROLLDOWN_FILE_URL_E41pjQhco8crdFKSeaw4IA